<section class="FT-all-funds watchlist-funds">
  <div *ngIf="isLoaded">
    <div *ngIf="dataCardToggle">
      <!-- Watch list content -->
      <section *ngIf="watchListingData?.length > 0">
        <ft-watch-list-content [brConfiguration]="brConfiguration" [fundData]="fundData"
                               [watchListingData]="watchListingData"
                               (toggleDataCard)="onToggleDataCard($event)" [sideFilterOptions]="sideFilterOptions"
                               [showWatchlist]="showWatchlist"></ft-watch-list-content>
      </section>
      <!-- Empty page -->
      <ng-container *ngIf="watchListingData?.length === 0">
        <div class="container">
          <div class="d-md-none back" style="display: flex">
            <div style="margin-right: 10px">
              <a style="cursor: pointer;" (click)="backClicked()">
                <img alt="Go Back" src="assets/images/general/arrowleft.webp">
                <img alt="Go Back" src="assets/images/fund/Vec.svg" class="mobile-icons dark-mode-icon"
                     style="width: 20px;">
              </a>
            </div>
          </div>
          <h3 class="filter-title mb-md-3 mb-2" id="forRoute">
            {{ "products.Watchlist-heading" | translate }}
          </h3>
        </div>

        <section class="FT-all-funds watchlist-funds empty-watchlist">
          <ft-empty-page [fundData]="fundData" [sideFilterOptions]="sideFilterOptions" [comaredCardImg]="true"
                         [brConfiguration]="brConfiguration" [cardTypeData]="'EMPTY_WATCHLIST'" [addFundData]="false"
                         pageSubHeading="{{
                'products.empty-page-subHeading' | translate
              }}">
          </ft-empty-page>
        </section>
      </ng-container>
    </div>
  </div>
  <div class="container" *ngIf="isLoaded === undefined && watchListingData?.length !== 0">
    <div class="text-center mb-5 mt-5">
      <div id="loader">
        <img src="assets/images/home/loader.gif" alt="Loading...">
      </div>
    </div>
  </div>
</section>
